  const apiSessionId = sessionStorage.getItem("sessionId");
  console.log("sessionId", apiSessionId);

export const BackButton = () => {
  return (
    <button
      className="btn btn-primary btn-sm"
      data-toggle="tooltip"
      data-placement="Left"
      title="Back to previous page"
      style={{
        backgroundColor: "#26b7ec",
        color: "black",
        border: '1px solid #26b7ec'
      }}
    >
      Back
    </button>
  );
};

const filterRejectedRecords = (data) => {
  return data.filter(item => (
    item.dataModel !== "BDM" && // Exclude records where dataModel is DEM
    item.active_yn !== "N" &&
    !["Ready for validation. (updated)", "\\N", "", "\N"].includes(item.Rejected_Reason) // Check invalid values correctly
  ));
};


export default filterRejectedRecords;
